import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { useField } from "formik";
import { TextField } from "@mui/material";

export default function FormSelect({ name, label, items = [], onChange: customOnChange }) {
  const [field, meta] = useField(name);

  const handleChange = (e) => {
    // Call Formik's field onChange first
    field.onChange(e);
    // Then call custom onChange if provided
    if (customOnChange) {
      customOnChange(e);
    }
  };

  return (
    <TextField
      select
      id="select"
      size="small"
      label={label}
      {...field}
      onChange={handleChange}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
    >
      {items.map((item, index) => (
        <MenuItem value={item.code} key={index}>
          {item.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
